import {
  createComponent,
  type ElementWithProps
} from '@carvana/merch-components';
import cx from 'classnames';

export const SwitchButton = createComponent<
  ElementWithProps<{
    isDisabled?: boolean;
    showOnBackground?: boolean;
  }>
>('div', props => ({
  className: cx(
    `
    -:isolate
    -:inline-flex
    -:flex-row
    -:flex-1
    -:relative
    -:bg-grey-1
    -:p-0
    -:border
    -:border-grey-2
    -:text-blue-6
    -:rounded-[38px]
    -:h-[40px]
    -:outline-none
    -:min-w-[56px]
    -:cursor-pointer
    -:transition
    -:w-full
  `,
    {
      'bg-blue-2': props.showOnBackground,
      'bg-transparent text-grey-3 opacity-70 pointer-events-none':
        props.isDisabled
    }
  )
}));

export const SlidingBackground = createComponent<
  ElementWithProps<{ isOn: boolean }>
>('div', props => ({
  className: cx(
    `
    -:bg-white
    -:h-[38px]
    -:w-[50%]
    -:min-w-[56px]
    -:rounded-[38px]
    -:absolute
    -:border-x
    -:border-grey-2
    -:transition
    -:translate-x-[-1px]
    -:duration-300
    -:ease-in-out
  `,
    {
      'translate-x-[100%]': props.isOn
    }
  )
}));

export const SwitchLabel = createComponent<
  ElementWithProps<{
    isSelected: boolean;
    showOnBackground?: boolean;
  }>
>('div', props => ({
  className: cx(
    `
      -:text-blue-2
      -:bg-transparent
      -:h-[38px]
      -:m-0
      -:flex-1
      -:leading-[37px]
      -:rounded-[38px]
      -:text-center
      -:text-[12px]
      -:uppercase
      -:font-bold
      -:outline-0
      -:select-none
      -:z-[1]
      hover:text-blue-3
      hover:no-underline
  `,
    {
      'text-[inherit]': props.isSelected,
      'text-blue-6 hover:text-[inherit]': props.showOnBackground
    }
  )
}));
